/**
 * Error Logger for Frontend
 * Saves errors to localStorage for phone debugging
 */

const MAX_LOGS = 50;

export const logError = (category, message, details = {}) => {
  const timestamp = new Date().toISOString();
  const logEntry = {
    timestamp,
    category,
    message,
    details,
    url: window.location.href,
    userAgent: navigator.userAgent.substring(0, 100)
  };
  
  // Get existing logs
  let logs = [];
  try {
    const stored = localStorage.getItem('errorLogs');
    if (stored) {
      logs = JSON.parse(stored);
    }
  } catch (e) {
    console.error('Failed to parse error logs:', e);
  }
  
  // Add new log
  logs.push(logEntry);
  
  // Keep only last MAX_LOGS
  if (logs.length > MAX_LOGS) {
    logs = logs.slice(-MAX_LOGS);
  }
  
  // Save
  try {
    localStorage.setItem('errorLogs', JSON.stringify(logs));
    console.log(`📝 Error logged: [${category}] ${message}`);
  } catch (e) {
    console.error('Failed to save error log:', e);
  }
};

export const getErrorLogs = () => {
  try {
    const stored = localStorage.getItem('errorLogs');
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    console.error('Failed to get error logs:', e);
    return [];
  }
};

export const clearErrorLogs = () => {
  localStorage.removeItem('errorLogs');
  console.log('📝 Error logs cleared');
};

export const downloadErrorLogs = () => {
  const logs = getErrorLogs();
  const blob = new Blob([JSON.stringify(logs, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `error-logs-${new Date().toISOString()}.json`;
  a.click();
  URL.revokeObjectURL(url);
};

